export default "../css/e382be2243e410d7d0f5e45a0ae2765e.ttf";